
import {O} from "web-vcore";
import {SamplesGraphYType} from "../../../UI/@Shared/NavBar/SettingsPanel/Transcribe/SamplesGraph.js";
import {ignore} from "mobx-sync";

export enum TranscribeSettingsSubpanel {
	config = "config",
	model = "model",
	test = "test",
}

export class TranscribeSettingsState {
	@O accessor subpanel = TranscribeSettingsSubpanel.config;

	// config
	@O accessor chunk_minDuration = 5; // in seconds; min duration of chunk to send to whisper to transcribe
	@O accessor chunk_maxDuration = 30; // in seconds; max duration of chunk to send to whisper to transcribe (30s is the hard-max)
	@O accessor chunk_minPeakVolume = 0; // range: 0 (no sound at all) - 1 (mic-samples maxed out)
	//@O chunk_minAverageVolume = 0; // range: 0 (no sound at all) - 1 (mic-samples maxed out)
	@O accessor silence_minDuration = 2; // in seconds
	@O accessor silence_maxPeakVolume = .01; // range: 0 (no sound at all) - 1 (mic-samples maxed out)
	//@O silence_maxAverageVolume = .002; // range: 0 (no sound at all) - 1 (mic-samples maxed out)
	@O accessor excludeEffectNotations = true;
	@O accessor voice_avoidTranscribePadding = 3; // in seconds

	// audio block storage
	@O accessor audioBlock_keepDays = 30; // 0 = disabled (never delete)

	// audio block time-sync
	@O @ignore accessor timeSyncActive = false;
	// remote cursor time-sync (ephemeral, not persisted)
	@O @ignore accessor remoteCursorState = {entryId: null as string|n, segmentId: null as string|n, timestamp: null as number|n};
	/** Signal for a remote play/pause request; id increments per request so AudioBlockPlayer fires exactly once per event. */
	@O @ignore accessor remotePlayPause: {play: boolean, id: number}|n = null;
	/** Playback rate for audio-block players; persisted so it survives refreshes. Remote proxy sets this on the receiver via bridge. */
	@O accessor audioPlaybackRate = 1;
	@O @ignore accessor cursorSendingActive = false;

	// model
	// (none; data is read/written on android side)

	// test
	@O accessor graphTimeToShow = 30; // in seconds
	@O accessor yType = SamplesGraphYType.absAvg;
	@O accessor smoothing = 0;
	@O @ignore accessor samplesGraph_active = false;
}